import { RepositoryFactory } from '../../repositoryFactory';
import router from '../../routes';

const CartRepository = RepositoryFactory.get('cart');

export default {
  state: {
    id: localStorage.getItem('cartId') || '',
    items: [],
    shipping_cost: 0,
    total_discount: 0,
    user: {},
  },
  getters: {
    id: (state) => state.id,
    items: (state) => state.items,
    total_items: (state) => _.sumBy(state.items, 'quantity'),
    totals: (state) => _.sumBy(state.items, (item) => item.quantity * (item.sale_price ? item.sale_price : item.price)),
    net_total: (state) => _.sumBy(state.items, (item) => item.quantity * (item.sale_price ? item.sale_price : item.price)) + state.shipping_cost - state.total_discount,
    user: (state) => state.user,
    coupon: (state) => state.coupon,
    shipping_cost: (state) => state.shipping_cost,
    total_discount: (state) => state.total_discount,
  },
  mutations: {
    get_success(state, payload) {
      state.id = payload.id;
      state.items = payload.data.items;
      state.shipping_cost = payload.data.shipping_cost;
      state.total_discount = payload.data.total_discount;
    },
    get_error(state) {
      state.id = '';
      state.items = [];
      state.shipping_cost = 0;
    },
    add_success(state, payload) {
      state.id = payload.id;
      state.items = payload.data.items;
    },
    update_success(state, payload) {
      state.items = payload.data.items;
    },
    remove_success(state, payload) {
      state.items = payload.data.items;
    },
    update_user(state, payload) {
      state.user = payload.data.user;
    },
    coupon_applied(state, payload) {
      state.coupon = payload.data.coupon;
    },
    coupon_error(state) {
      state.coupon = {};
    },
    empty(state) {
      state.items = [];
      state.coupon = {};
    },
  },
  actions: {
    get({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CartRepository.get(payload).then((resp) => {
          localStorage.setItem('cartId', resp.data.id);
          commit('get_success', resp.data);
          resolve(resp);
        }).catch((err) => {
          commit('get_error');
          reject(err);
        });
      });
    },
    add({ commit }, payload) {
      payload.redirect = payload.redirect ?? true;
      return new Promise((resolve, reject) => {
        CartRepository.store(payload).then((resp) => {
          const { id, data } = resp.data;
          localStorage.setItem('cartId', id);
          if (typeof payload.redirect !== 'undefined' && payload.redirect) {
            router.push({ name: 'cart' });
          }
          commit('add_success', { id, data });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CartRepository.update(payload).then((resp) => {
          const { id, data } = resp.data;
          commit('update_success', { id, data });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    remove({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CartRepository.remove(payload.id, payload.itemId).then((resp) => {
          const { id, data } = resp.data;
          commit('remove_success', { id, data });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    update_user({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CartRepository.update(payload).then((resp) => {
          const { id, data } = resp.data;
          commit('update_user', { id, data });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    apply_coupon({ commit }, payload) {
      return new Promise((resolve, reject) => {
        CartRepository.apply_coupon(payload.id, payload.couponCode).then((resp) => {
          const { id, data } = resp.data;
          commit('coupon_applied', { id, data });
          resolve(resp);
        }).catch((err) => {
          commit('coupon_error');
          reject(err);
        });
      });
    },
    empty({ commit }) {
      commit('empty');
    },
  },
};
